if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // Kilja: the modal is a one-at-a-time viewer (arrows, keys, swipe) instead of a scrolling stack.
      items() {
        return [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
      }

      showActiveMedia() {
        this.go(this.items().findIndex((el) => el.dataset.mediaId === this.openedBy.getAttribute('data-media-id')));
      }

      go(index) {
        const items = this.items();
        if (!items.length) return;
        this.index = (index + items.length) % items.length;
        if (window.pauseAllMedia) window.pauseAllMedia();
        items.forEach((el, i) => el.classList.toggle('active', i === this.index));
        const active = items[this.index];
        if (active.nodeName === 'PRODUCT-MODEL' || (active.nodeName === 'DEFERRED-MEDIA' && active.querySelector('template'))) {
          active.loadContent(false);
        }
        this.buildNav(items.length);
        this.counter.textContent = `${this.index + 1} / ${items.length}`;
      }

      buildNav(count) {
        if (this.nav) return;
        const dialog = this.querySelector('.product-media-modal__dialog');
        this.nav = document.createElement('div');
        this.nav.className = 'kilja-lb__nav';
        this.nav.innerHTML =
          '<button type="button" class="kilja-lb__btn" data-dir="-1" aria-label="Fyrri mynd">&#8592;</button>' +
          '<span class="kilja-lb__count" aria-live="polite"></span>' +
          '<button type="button" class="kilja-lb__btn" data-dir="1" aria-label="Næsta mynd">&#8594;</button>';
        if (count < 2) this.nav.hidden = true;
        dialog.appendChild(this.nav);
        this.counter = this.nav.querySelector('.kilja-lb__count');
        this.nav.addEventListener('click', (e) => {
          const b = e.target.closest('[data-dir]');
          if (b) this.go(this.index + Number(b.dataset.dir));
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.go(this.index + 1);
          if (e.key === 'ArrowLeft') this.go(this.index - 1);
        });
        let x0 = null;
        this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null || this.querySelector('.product-media-modal__content > .active model-viewer')) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
    }
  );
}
